import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import { useAppContext } from "../../context/AppContext";
import { useUserData } from "../../hooks/useUserData";
import { usePodData } from "../../hooks/usePodData";
import { endSession } from "../../utils/api";
import { APP_CONFIG } from "../../constants";
import "./EndSession.css";
import exitIcon from "../../assets/icons/exit.svg";
import welcomeVideo from "../../assets/videos/welcome.mp4";
import HomeIcon from "../../assets/icons/home.svg";

const EndSession = () => {
  const navigate = useNavigate();
  const { t, isRTL } = useLocalization();
  const { savedAnswers, clearAnswers, resetState } = useAppContext();
  const { userData } = useUserData();
  const { podData } = usePodData();

  const handleEndSession = async () => {
    try {
      const sessionId = userData?.sessionId;
      const podIP = podData?.ip;

      if (sessionId && podIP) {
        await endSession(podIP, sessionId);
      }

      // Clear saved answers and reset state
      Object.keys(savedAnswers).forEach((assessmentId) => {
        clearAnswers(assessmentId);
      });
      resetState();

      // Navigate to dashboard
      navigate(APP_CONFIG.ROUTES.DASHBOARD);
    } catch (error) {
      // Continue with cleanup even if API call fails
      Object.keys(savedAnswers).forEach((assessmentId) => {
        clearAnswers(assessmentId);
      });
      resetState();
      navigate(APP_CONFIG.ROUTES.DASHBOARD);
    }
  };

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <h1 className="welcome-title">{t("endSession.title")}</h1>
        <button className="welcome-start-button" onClick={handleEndSession}>
          {t("endSession.endButton")}
          <img
            src={exitIcon}
            alt="arrow"
            className="arrow-icon"
            style={{
              transform: isRTL ? "rotate(180deg)" : "none",
              marginLeft: isRTL ? 0 : "1vw",
              marginRight: isRTL ? "1vw" : 0,
              transition: "transform 0.3s ease",
            }}
          />
        </button>
      </div>
      <video className="welcome-video" autoPlay loop muted playsInline>
        <source src={welcomeVideo} type="video/mp4" />
      </video>

      <div className="assessment-footer">
        <button
          className="footer-btn home-btn"
          onClick={() => navigate("/dashboard")}
        >
          <img src={HomeIcon} alt="Home" />
        </button>
      </div>
    </div>
  );
};

export default EndSession;
